module.exports = __webpack_public_path__ + "img/brook.8ad82843.svg";